import * as api from '@yandex-int/k-common/client/api';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { LessonProblem, Stack } from '@yandex-int/k-common/typings';
import { call, put, select } from 'redux-saga/effects';

import * as lessonSelectors from 'common.components/lesson/selectors';

import * as actions from '../actions';
import * as selectors from '../selectors';

export function* getProblemStacks() {
    try {
        const loadingStatus: LOADING_STATUSES = yield select(selectors.getProblemStacksRequestStatus);
        if (loadingStatus === LOADING_STATUSES.SUCCESS) {
            return;
        }

        const problems: Array<LessonProblem> = yield select(lessonSelectors.getLessonProblems);
        const stackIds = problems.map((p) => p.from_theme).filter((id) => Boolean(id));

        if (!stackIds.length) {
            yield put(actions.getProblemStacksSuccess({ stacks: [] }));
            return;
        }

        const courseId: number | null = yield select(lessonSelectors.getLessonOrCurrentYearCourseId);

        const stacks: Stack[] = yield call(api.getStacks, { stackIds, courseId, showProblems: false });

        yield put(actions.getProblemStacksSuccess({ stacks }));
    } catch (error) {
        console.error(error);
        yield put(actions.getProblemStacksError());
    }
}
